var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.is_logging_in && _vm.$route.name !== 'Login')?_c('div',{attrs:{"id":"loading-padding"}},[_c('v-progress-circular',{attrs:{"size":50,"color":"primary","indeterminate":""}})],1):_c('div',[_c('router-view',{attrs:{"login_checked":!_vm.is_logging_in}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }